// extracted by mini-css-extract-plugin
export default {"error":"Stars_error__a2LKy","root":"Stars_root__jnRjK","active":"Stars_active__kfCsC"};